import fetcher from '../lib/fetcher'
import {TClient, TCreateClient, TUpdateClient} from '../types/client.type'

const createClient = async (clientData: TCreateClient) => {
  const response = await fetcher.post<TCreateClient, TClient>(
    `/api/client`,
    clientData,
  )
  if (!response.data) {
    throw new Error('Failed to create client')
  }
  return response.data
}

const getUsersClients = async () => {
  const res = await fetcher.get<TClient[]>('/api/client')
  return res.data
}

const updateClient = async (
  clientId: string,
  clientData: TUpdateClient,
): Promise<TClient> => {
  const response = await fetcher.patch<TUpdateClient, TClient>(
    `/api/client/${clientId}`,
    clientData,
  )
  if (!response.data) {
    throw new Error('Failed to update client')
  }
  return response.data
}

const softDeleteClient = async (clientId: string) => {
  const response = await fetcher.del(`/api/client/${clientId}`)
  if (!response.data) {
    throw new Error('Failed to soft delete client')
  }
  return response.data
}

const ClientService = {
  getUsersClients,
  createClient,
  updateClient,
  softDeleteClient,
}

export default ClientService
